export const wcErrorCodeToMessageEn = {
  fallback: "An error occurred. Please try again.",
  woocommerce_rest_product_out_of_stock: "Sorry, the product is out of stock.",
  woocommerce_rest_product_partially_out_of_stock: "Sorry, the product is out of stock.",
  woocommerce_rest_cart_invalid_product: "This product cannot be added to the cart.",
  rest_invalid_param: "Invalid input",
  woocommerce_rest_cart_coupon_error: "This coupon is not applicable to the products in the cart.",
}

export const wcErrorCodeToMessageDe: typeof wcErrorCodeToMessageEn = {
  fallback: "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
  woocommerce_rest_product_out_of_stock: "Es tut uns leid, das Produkt ist leider nicht mehr vorrätig.",
  woocommerce_rest_product_partially_out_of_stock: "Es tut uns leid, das Produkt ist leider nicht mehr vorrätig.",
  woocommerce_rest_cart_invalid_product: "Dieses Produkt kann nicht zum Warenkorb hinzugefügt werden.",
  rest_invalid_param: "Ungültige Eingabe",
  woocommerce_rest_cart_coupon_error: "Dieser Gutschein ist auf die Produkte im Warenkorb nicht anwendbar.",
}

export function extractWcErrorMessage(error: unknown) {
  let errorMessage = wcErrorCodeToMessageDe.fallback
  let isFallback = true
  let isValidation = false

  if (!(error instanceof Error)) {
    return { errorMessage, isFallback, isValidation }
  }

  const json = error.message.slice(error.message.indexOf("{"), error.message.lastIndexOf("}") + 1)

  if (json) {
    try {
      const data: { code: string; message: string } = JSON.parse(json)

      errorMessage = data.message
      isFallback = false
      isValidation = data.code === "rest_invalid_param"
    } catch (error) {
      console.error(error)
    }
  }

  if (errorMessage === wcErrorCodeToMessageDe.fallback) {
    for (const key of Object.keys(wcErrorCodeToMessageDe)) {
      if (error.message.includes(key)) {
        errorMessage = wcErrorCodeToMessageDe[key as keyof typeof wcErrorCodeToMessageEn]
        isFallback = false
        isValidation = key === "rest_invalid_param"
        break
      }
    }
  }

  return { errorMessage, isFallback, isValidation }
}
